import { _axios } from "../../../Utils/Axios/axios";

export const showQuestionsOfBoughtQuiz = async (
  userToken: string,
  quizId: string | number
) => {
  return _axios.post(
    `/show_questions_of_quiz/${quizId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
